import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

const PaRes = (props) => {
  useLayoutEffect(() => {
    document.head.innerHTML = '';
    const meta = document.createElement('meta');
    meta.httpEquiv = 'Content-Type';
    meta.content = 'text/html; charset=UTF-8';
    document.head.appendChild(meta);
  }, []);

  const [submitted, setSubmitted] = useState(null);

  const submitForm = (form) => {
    if (!form) return;
    if (!submitted) {
      setSubmitted(true);
      form.submit();
    }
  };

  const { url, response, md } = props;
  return (
    <form name="mainform" method="POST" action={url} ref={submitForm}>
      <div style={{ display: 'none' }}>
        Transaction Successful...
        <input type="hidden" id="PaRes" name="PaRes" value={response} />
        <input type="hidden" id="MD" name="MD" value={md || ''} />
      </div>
    </form>
  );
};

PaRes.propTypes = {
  url: PropTypes.string.isRequired,
  response: PropTypes.string.isRequired,
  md: PropTypes.string.isRequired,
};

export default PaRes;
